import { useAppDispatch, useAppSelector } from '@app/store/store';
import { useCallback } from 'react';

import type { AdvancedEditDraft } from '../../../../../../domain';
import {
  selectActiveAdvancedEdit,
  selectActiveEditDraft,
} from '../../../../../../selector';

export const useEditDraftUpdate = () => {
  const dispatch = useAppDispatch();
  const activeEdit = useAppSelector(selectActiveAdvancedEdit);
  const currentDraft = useAppSelector(selectActiveEditDraft);

  const updateDraft = useCallback(
    (buildNextDraft: (draft: AdvancedEditDraft) => AdvancedEditDraft) => {
      const editId = activeEdit?.id;
      if (!editId || !currentDraft) {
        return;
      }
      dispatch({
        type: '[advanced-editor] edit draft changed',
        payload: {
          editId,
          draft: buildNextDraft(currentDraft),
          previousDraft: currentDraft,
        },
      });
    },
    [activeEdit?.id, currentDraft, dispatch],
  );

  return { currentDraft, updateDraft, editId: activeEdit?.id };
};
